import { Kitchen, MenuItem } from "../types/index";

// Matches ConcentricDial's DialItem
export interface DialNode {
  id: string;
  name: string;
  icon?: any;
  type: "kitchen" | "category" | "variant";
  price?: number;
  data?: any; // ✅ Used to pass full item object
  children?: DialNode[];
}

export const transformMenuToDialData = (flatItems: any[]): DialNode[] => {
  const tree: DialNode[] = [];
  const kitchenMap = new Map<string, DialNode>();

  flatItems.forEach((item) => {
    // 1. Kitchen
    const kName = item.kitchenName || "Unknown Kitchen";
    const kId = item.kitchenId;

    if (!kitchenMap.has(kId)) {
      kitchenMap.set(kId, {
        id: kId,
        name: kName,
        type: "kitchen",
        children: [],
      });
      tree.push(kitchenMap.get(kId)!);
    }

    const kitchenNode = kitchenMap.get(kId)!;

    // 2. Category
    const catName = item.category || item.cuisineTags?.[0] || "General";
    const catId = `${kId}_${catName.replace(/\s+/g, '_')}`;

    let categoryNode = kitchenNode.children!.find((c) => c.id === catId);

    if (!categoryNode) {
      categoryNode = {
        id: catId,
        name: catName,
        type: "category",
        children: [],
      };
      kitchenNode.children!.push(categoryNode);
    }

    // 3. Variant (Leaf)
    categoryNode.children!.push({
      id: item.id,
      name: item.name,
      type: "variant",
      price: item.price,
      data: item, // ✅ Stores original item for cart
    });
  });

  return tree;
};